import { createFileRoute } from '@tanstack/react-router';
import { FinanceAccountsScreen } from '../../screens/finance/Accounts';

export const Route = createFileRoute('/finance/accounts')({
  component: FinanceAccountsScreen,
});
